import { Button, useToast } from '@chakra-ui/react';
import * as React from 'react';

import { useEditPromotion } from '@/components/organizations/hooks/useEditPromotion';
import { logError } from '@/imports/logging/ClientLogger';

export const PublishButton: React.FC<{ adId: string }> = ({ adId }) => {
  const toast = useToast();

  const {
    update: [updateAd, { loading }],
  } = useEditPromotion();

  const publishPromotion = async (): Promise<void> => {
    try {
      await updateAd({
        variables: {
          input: { id: adId, data: { published: true } },
        },
      });
      toast({
        title: 'Published promotion',
        status: 'success',
      });
    } catch (err) {
      toast({
        title: 'Failed to publish promotion',
        status: 'error',
      });
      logError(err);
    }
  };

  return (
    <Button mt="4" w="full" isLoading={loading} onClick={publishPromotion}>
      Publish Promotion
    </Button>
  );
};
